import React from 'react';
import styled, { css } from 'styled-components';
import { DIMENSIONS } from '../defaultConfig.js';
import { useScreenSize } from '../utils/hooks/useScreenSize.js';
import { media, mediaBetween } from '../utils/layout.js';

const Hidden = ({
  children,
  isLoadingHtml = false,
  ...screenSizes
}) => {
  const screenSize = useScreenSize();
  if (isLoadingHtml) {
    return React.createElement(HiddenWrap, {
      $classes: screenSizes
    }, children);
  }
  return screenSizes[screenSize] ? null : children;
};
const HiddenWrap = styled(({
  children,
  ...props
}) => React.cloneElement(children, props)).withConfig({
  displayName: "Hidden__HiddenWrap",
  componentId: "sc-clnwj5-0"
})(["", ""], ({
  $classes,
  theme
}) => DIMENSIONS.map((size, index) => {
  if ($classes[size]) {
    return DIMENSIONS.length - 1 === index ? css`${media(size, theme)} {
                    display: none!important;
                }` : css`${mediaBetween(size, DIMENSIONS[index + 1], theme)} {
                    display: none!important;
                }`;
  }
  return null;
}));
Hidden.displayName = 'Hidden';
var Hidden$1 = Hidden;

export { Hidden$1 as default };
//# sourceMappingURL=Hidden.js.map
